<div class="modal-header" *ngIf="openedFromWorkbench">
	<h5 class="modal-title fw-bold"><span jhiTranslate="lot-creation.title"></span></h5>
	<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="close()">
	</button>
</div>
<div class="modal-body">
	<form name="form" #f="ngForm" class="form-horizontal">

		<div class="mb-3 row" [class.has-error]="!stockIdPrefix.valid">
            <label for="stockIdPrefix" class="col-4 col-form-label">
                <span jhiTranslate="inventoryManagerApp.lot.create.field.stock.id.prefix">Stock ID Prefix</span>
                <i class="fa fa-info-circle col-1 help-icon ms-3" data-bs-toggle="tooltip" data-bs-placement="top" ngbTooltip="{{ 'inventoryManagerApp.lot.create.field.stock.id.title' | translate }}"></i>
            </label>
			<div class="col-sm-4">
                <div class="form-group row">
					<div class="col">
						<input type="text" jhi-stockIdPrefixValidator  class="form-control col-4" name="stockIdPrefix" id="stockIdPrefix" [(ngModel)]="model.stockIdPrefix" #stockIdPrefix="ngModel"/>
                        <div class="invalid-feedback d-block" *ngIf="stockIdPrefix.invalid">
                            <small jhiTranslate="inventoryManagerApp.lot.create.field.stock.id.prefix.error"></small>
                        </div>
					</div>
				</div>

				<div class="form-group row" *ngIf="showReuseSrcObsUnitToggle">
					<div class="col">
						<div class="form-check">
							<input type="checkbox" title="{{ 'lot-creation.reuse.source.observation.unit.id.as.lot.uid' | translate }}"
								   class="form-check-input" [(ngModel)]="isReuseSrcObservationUnitId"
								   id="isReuseSrcObservationUnitId" name="isReuseSrcObservationUnitId">
							<label class="form-check-label" for="isReuseSrcObservationUnitId"><span jhiTranslate="lot-creation.reuse.source.observation.unit.id.as.lot.uid"></span></label>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="mb-3 row required">
			<label class="col-sm-4 col-form-label" jhiTranslate="lot-creation.field.storage.loc">
				Storage Location
			</label>
			<div class="col-sm-4">
				<jhi-locations-select [(value)]="storageLocIdSelected" [showFilterOptions]="true" [storageLocationsOnly]="true" [clearable]="false"></jhi-locations-select>
			</div>
		</div>
		<div class="mb-3 row" [class.has-error]="!dropdownUnits.valid">
			<label for="dropdownUnits" class="col-sm-4" jhiTranslate="lot-creation.field.units">Units</label>
			<div class="col-sm-4">
				<select class="form-select" name="dropdownUnits" id="dropdownUnits" [(ngModel)]="lot.unitId" [required]="isDepostiRequired()" #dropdownUnits="ngModel" (change)="unitChanged()">
					<option *ngFor="let unit of units | async" [value]="unit.id">
						<label>{{unit.name}}</label>
					</option>
				</select>
			</div>
		</div>
		<div class="mb-3 row">
			<label for="lotNotes" class="col-sm-4 col-form-label" jhiTranslate="lot-creation.field.notes">Notes</label>
			<div class="col-sm-4">
				<textarea class="form-control" rows="3" name="lotNotes" id="lotNotes" [(ngModel)]="lot.notes" #lotNotes="ngModel" jhi-forbiddenCharactersValidator></textarea>
			</div>
		</div>
		<div>
			<h4 class="modal-title" jhiTranslate="lot-creation.field.deposit">Deposit</h4>
			<div class="mb-3 row">
				<label class="col-sm-4 col-form-label" [hidden]="initialDepositRequired">
					<div class="form-check">
						<input type="checkbox" class="form-check-input" [(ngModel)]="initialDepositCheckbox" name="depositAvailable" id="depositAvailable">
						<label class="form-check-label" for="depositAvailable" jhiTranslate="lot-creation.field.initial.deposit">
							Initial deposit
						</label>
					</div>
				</label>
			</div>
		</div>
		<div class="border-top my-3">
		</div>
		<br>
		<div *ngIf="!isSeedAmountUndefined">
			<div class="mb-3 row" [ngStyle]="{'margin-bottom': depositAmount.touched && depositAmount.invalid ? '0px':'16px'}">
				<label for="depositAmount" class="col-sm-4 col-form-label" jhiTranslate="lot-creation.field.amount">Amount</label>
				<div class="col-sm-4">
					<input type="number" class="form-control" name="depositAmount" id="depositAmount" [disabled]="!isDepostiRequired()"
						   [(ngModel)]="deposit.amount" jhi-customMinGreaterThanValidator min="0" #depositAmount="ngModel"
						   [ngClass]="{ 'is-invalid': f.submitted && depositAmount.invalid }" [required]="isDepostiRequired()"/>
                    <div [hidden]="!(depositAmount.touched && depositAmount.invalid)">
                        <small class="invalid-feedback d-block" jhiTranslate="inventoryManagerApp.lot.create.field.amount.note">
                            Initial amount must be higher than zero
                        </small>
                    </div>
				</div>
			</div>
		</div>

		<div class="mb-3 row" *ngIf="isSeedAmountUndefined">
			<label for="undefinedDepositAmount" class="col-sm-4 col-form-label" jhiTranslate="lot-creation.field.amount">Amount</label>
			<div class="col-sm-4">
				<input type="number" class="form-control" name="undefinedDepositAmount" id="undefinedDepositAmount" [disabled]="true"
					   [(ngModel)]="deposit.amount" #undefinedDepositAmount="ngModel" [required]="isDepostiRequired()"/>
			</div>
		</div>

		<div class="mb-3 row">
			<label for="depositNotes" class="col-sm-4 col-form-label" jhiTranslate="lot-creation.field.notes">
				Notes
			</label>
			<div class="col-sm-4">
				<div class="mb-3 row">
					<div class="col">
						<textarea class="form-control" rows="3" name="depositNotes" id="depositNotes" [disabled]="!isDepostiRequired()" [(ngModel)]="deposit.notes" #depositNotes="ngModel" jhi-forbiddenCharactersValidator></textarea>
					</div>
				</div>
				<div class="mb-3 row" *ngIf="!isSeedAmountUndefined">
					<div class="col">
						<div class="form-check">
							<input type="checkbox" class="form-check-input" [(ngModel)]="isConfirmDeposit" id="isConfirmDeposit" name="isConfirmDeposit" [disabled]="!isDepostiRequired()">
							<label class="form-check-label" for="isConfirmDeposit"><span jhiTranslate="lot-creation.confirm.transactions.checkbox.label"></span></label>
						</div>
					</div>
				</div>
			</div>
		</div>
	</form>
</div>
<div class="modal-footer">
	<button *ngIf="openedFromWorkbench" type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="clear()">
		<span jhiTranslate="entity.action.cancel">Cancel</span>
	</button>
	<button (click)="save()" [disabled]="f.form.invalid || isSuccess || isLoading" class="btn btn-primary" data-test="createLotsButton">
		<span *ngIf="isLoading" class="throbber throbber-btn"></span>
		<span class="fa fa-save"></span>&nbsp;<span jhiTranslate="entity.action.save">Save</span>
	</button>
</div>

